import React from 'react';
import PropTypes from 'prop-types';
import isResizable from '../../../../mixins/resizable';
import { ArrowLeft } from 'lucide-react';

// Modules
import Window from '../../../../../modules/window';

// Base
import Button from '../../../base/button';

// Related Components
import Calendar from './book_a_call/calendar';
import LogoutLogo from '../../../agents/subscribe/logout_logo';
import Progress from './progress';

class BookACall extends React.Component {
  static propTypes = {
    onSetView: PropTypes.func.isRequired,
    showProgress: PropTypes.bool,
    redirectTo: PropTypes.string,
  }

  static defaultProps = {
    showProgress: false,
    redirectTo: '/',
  }

  get backView() {
    const { showProgress } = this.props;
    return showProgress ? 'discovery_source' : 'user_type';
  }

  render() {
    const { onSetView, showProgress, redirectTo } = this.props;

    return (
      <React.Fragment>
        <div className='height-60 margin-bottom-70'>
          <LogoutLogo />
        </div>
        <div className='width-560 margin-center relative'>
          <div className='absolute left--45'>
            <ArrowLeft {...{
              size: 24,
              onClick: () => onSetView(this.backView),
              className: 'cursor-pointer',
            }} />
          </div>
          {
            showProgress &&
            <div className='width-400 padding-top-25'>
              <Progress {...{
                value: 4,
                max: 4,
              }} />
            </div>
          }
          <div className='margin-bottom-10 xlg-font semi-bold line-height-26'>Let's connect to help select the best plans suited to you.</div>
          <Calendar />
          {
            showProgress &&
            <div className='margin-top-0 center-align'>
              <Button {...{
                className: 'sm-font margin-top-30 underline',
                text: 'Schedule Later',
                size: 'custom',
                onClick: () => Window.redirect(redirectTo),
              }} />
            </div>
          }
        </div>
      </React.Fragment>
    )
  }
}

export default isResizable(BookACall);